<template lang="pug">
	div(style="position:relative;display:block;width:100%;")
		div.bg-white.buzon(
			v-for="buzon in listado"
			:key="buzon.BuzonID"
		)
			div.tituloBuzon(:style="estilo", :class="(activo === buzon) ? 'bg-warning' : ''", @dblclick="toggleExpandir($event, buzon.BuzonID)", @click="selecciona(buzon)")
				div(style="cursor: pointer; position:relative;display:inline-block;width:10px;", @click="toggleExpandir($event, buzon.BuzonID)")
					span(v-if="buzon.buzonesHijos.length > 0")
						span(v-if="expandir.indexOf(buzon.BuzonID) >= 0") -
						span(v-else) +
				div(style="display:inline-block")
					span.fa.fa-folder.mr-2(:style="estiloBuzon(buzon)")
				div(style="display:inline-block") {{ buzon.BuzonDescripcion }}
			arbol-buzones(:listado="buzon.buzonesHijos", v-if="buzon.buzonesHijos.length > 0 && expandir.indexOf(buzon.BuzonID) >= 0", :nivel="nivel + 1", :activo="activo", @select="selecciona")

</template>
<script>
import ArbolBuzones from './arbol-buzones.vue'
export default {
	name: 'arbol-buzones',
	components: {
		'arbol-buzones': ArbolBuzones
	},
	props: ['listado', 'nivel', 'activo'],
	data () {
		return {
			expandir: []
		}
	},
	computed: {
		estilo () {
			return {
				paddingLeft: (5 + (this.nivel * 10)) + 'px',
				cursor: 'default'
			}
		}
	},
	methods: {
		toggleExpandir (e, BuzonID) {
			e.preventDefault()
			e.stopPropagation()
			const idx = this.expandir.indexOf(BuzonID)

			if (idx >= 0) {
				this.expandir.splice(idx, 1)
			} else {
				this.expandir.push(BuzonID)
			}
		},
		estiloBuzon (buzon) {
			let hex = buzon.Color.toString(16)
			const reverse = (str) => {
				return (str === '') ? '' : reverse(str.substr(1)) + str.charAt(0)
			}
			hex = reverse(hex)

			// Calculamos si la cadena es de 6
			while (hex.length < 6) {
				hex = hex + '0'
			}
			hex = (hex.toLowerCase() === 'ffffff') ? '000000' : hex
			return {
				color: '#' + hex
			}
		},
		selecciona (buzon) {
			this.$emit('select', buzon)
		}
	}
}
</script>

<style scoped>
	.buzon {
		border-bottom: 1px solid #e0e0e0;
	}

	.buzon:first {
		border-top: 1px solid #e0e0e0;
	}

	.buzon:last-of-type {
		border-bottom: none;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/organizar-emisoras/vue/paginas/organizar/arbol-buzones.vue